import { useAppTranslation } from '@flowus/common/i18n';
import type { FC } from 'react';
import { PreviewPageContent } from 'src/components/preview-page-content';
import { useObservableBlock } from 'src/services/rxjs-redux/use-obs-block';
import { PageScene } from 'src/views/main/scene-context';

interface Props {
  id: string;
  preview?: boolean;
}
export const ChartPreview: FC<Props> = (props) => {
  const collectionId = useObservableBlock(props.id, (s) => s?.data.format?.chartFormat?.ref?.uuid);
  const { t } = useAppTranslation();
  if (!collectionId) {
    return (
      <div className="w-full h-full flex items-center justify-center text-grey4">
        {t('editor.component.chart.chart_config_panel.chart_preview.select_data_source')}
      </div>
    );
  }
  return (
    <PreviewPageContent
      docId={props.id}
      pageScene={props.preview ? PageScene.PAGE_CHART : PageScene.MAIN}
    />
  );
};
